import { FLEXIBLE_SIDES_REGION_IDS } from 'common/Constants';
import { get } from 'lodash';
import { MealPlanFormat, useGetShefsForRegionQuery } from 'src/gqlReactTypings.generated.d';
import { useCachedZipCode } from 'src/user-preferences/useCachedZipCode';
import { NonSubscriberPageContent } from './NonSubscriberPageContent';

interface NonSubscriberPageProps {}

const LIMIT_SHEFS_FOR_CAROUSEL = 15;
export const NonSubscriberPage: React.FC<NonSubscriberPageProps> = () => {
  const [, , zipCodeMetaData] = useCachedZipCode();
  const regionId = get(zipCodeMetaData, 'cachedZipCodeData.zipCode.region.id', null);
  const isFlexibleSidesRegion = FLEXIBLE_SIDES_REGION_IDS.includes(regionId);

  const { data } = useGetShefsForRegionQuery({
    variables: {
      regionId,
      mealPlanType: isFlexibleSidesRegion ? MealPlanFormat.FlexibleSides : MealPlanFormat.MainsPlusSides,
      limit: LIMIT_SHEFS_FOR_CAROUSEL,
    },
  });
  const shefs = data?.getMealPlanShefsForRegionId?.shefs ?? [];

  return <NonSubscriberPageContent shefs={shefs} />;
};
